export function getProductionArchiveViewState({ status, rowCount, total }) {
  const hasRows = Number(rowCount) > 0;
  const hasTotal = Number(total) > 0;

  return {
    countLabel: status === "loading" && !hasRows && !hasTotal ? "…" : total,
    showSkeleton: status === "loading" && !hasRows,
    showError: status === "error",
    showEmpty: status === "loaded" && !hasRows,
  };
}
